import { render, staticRenderFns } from "./changeOrderStatusModal.vue?vue&type=template&id=1be94aec&"
import script from "./changeOrderStatusModal.vue?vue&type=script&lang=js&"
export * from "./changeOrderStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports